module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAAAXNSR0IArs4c6QAAARJJREFUOBFjYBhsgHH+/PkG//79S/z//z8nOY5jZGT8DtQ/l+XPnz/rgAYokmMISA/QASDKgwlo4isQixIAMoMJCKKAjBfkGgTU+wyoN4YpKSnpHtB57kCBD2QY9p6FhcUtJSXlIRNIc2pq6iWgQb5A5ncSDPsG9I13QkLCVZAesEEgRnJy8hGgYeFA5h8QnwD4DTQkBKjnOEwd3CCQANCJm4GGpQAxOCpgipBpkBzQkESgIduRxVEMAkkADVsIDLNSZEVo7EKgIUvRxBBeQ5YAhlkv0OYuZDEQGyjWCrRoIro4WA6bIExszpw5c4GuS4LyZwEtSIfJodOM6ALIfKAhTEDDQoEu+Qf0zloQjSxPEzYAM1FSuwMCDUMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/assets/icons/down.png
// module id = 36
// module chunks = 58